import { useModal } from '../modal';

import './index.css';

const rulesSections = [
    {
        title: '1. Respect Every Adventurer',
        items: [
            'Treat players and staff with respect in chat, forums, and private messages.',
            'Harassment, hate speech, threats, and impersonation are not allowed.'
        ]
    },
    {
        title: '2. Fair Play Only',
        items: [
            'Using bots, macros, packet tools, or automation to gain an advantage is forbidden.',
            'Any exploit or bug abuse must be reported immediately.'
        ]
    },
    {
        title: '3. Account Responsibility',
        items: [
            'You are responsible for activity on your account.',
            'Do not share accounts, and keep your password secure.'
        ]
    },
    {
        title: '4. Naming and Content',
        items: [
            'Character, guild, and account names must be appropriate and non-offensive.',
            'Inappropriate names or messages may be changed or removed by staff.'
        ]
    },
    {
        title: '5. Real-World Trading',
        items: [
            'Selling characters, items, or accounts for real money is prohibited unless explicitly approved.',
            'Scams or fraudulent trades may lead to immediate penalties.'
        ]
    },
    {
        title: '6. Enforcement',
        items: [
            'Staff decisions are final for moderation and account actions.',
            'Penalties can include warnings, temporary suspensions, or permanent bans depending on severity.'
        ]
    },
    {
        title: '7. Staff Discretion',
        items: [
            'If staff determine behavior is harmful to the server, community, or fair play, they may treat it as a rule violation even when it is not listed word-for-word above.',
            'This policy exists to cover edge cases and protect the integrity of the game.'
        ]
    }
];

const RulesModal = () => {
    const { closeModal } = useModal();

    return (
        <div id='rules-modal'>
            <div id='rules-modal-shell'>
                <div id='rules-modal-header'>
                    <h2>Server Rules</h2>
                    <button
                        id='rules-modal-close'
                        type='button'
                        className='button'
                        title='Close rules'
                        onClick={closeModal}
                    >
                        Close
                    </button>
                </div>

                <div id='rules-modal-content'>
                    <p className='rules-modal-intro'>
                        Please read these rules before creating or playing on an account.
                        By checking the sign-up agreement box and continuing, you agree to follow all policies listed below.
                    </p>

                    {rulesSections.map((section) => (
                        <section className='rules-modal-section' key={section.title}>
                            <h3>{section.title}</h3>
                            <ul>
                                {section.items.map((item) => <li key={item}>{item}</li>)}
                            </ul>
                        </section>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default RulesModal;
